import { PERCENT_SCALE } from '@air/utilities';

export const BOARD_COVER_CENTER_POSITION = 50;

export const boardCoverPosition = ({ offset, extent }: { offset: number; extent: number }) => {
  if (extent >= PERCENT_SCALE) {
    return BOARD_COVER_CENTER_POSITION;
  }

  return (offset / (PERCENT_SCALE - extent)) * PERCENT_SCALE;
};

export const clampBoardCoverPosition = (position: number) => Math.max(0, Math.min(PERCENT_SCALE, position));

const remainingBoardCoverPercent = (visiblePercent: number) => PERCENT_SCALE - visiblePercent;

export const boardCoverRegionOffset = ({ position, visiblePercent }: { position: number; visiblePercent: number }) =>
  (position * remainingBoardCoverPercent(visiblePercent)) / PERCENT_SCALE;
